import {
    UPDATE_GPS_LOCATION,
  } from "../store/types";
  
  const INITIAL_STATE = {
    location: null,
    error: false
  }
export const gpsreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case UPDATE_GPS_LOCATION:
            // More robust validation of GPS data
            if (action.payload && action.payload.error) {
                // Explicit error state
                return {
                    location: null,
                    error: true
                };
            }
            
            if (action.payload && 
                action.payload.lat && 
                action.payload.lng &&
                typeof action.payload.lat === 'number' &&
                typeof action.payload.lng === 'number' &&
                !isNaN(action.payload.lat) &&
                !isNaN(action.payload.lng) &&
                action.payload.lat >= -90 && action.payload.lat <= 90 &&
                action.payload.lng >= -180 && action.payload.lng <= 180) {
                // Valid GPS coordinates
                return {
                    location: action.payload,
                    error: false
                };
            }
            
            // Invalid or missing data - treat as error
            console.log('DEBUG gpsreducer: Invalid GPS data received:', action.payload);
            return {
                location: null,
                error: true
            };
        default:
            return state;
    }
};